import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mp-zendesk-feedback-button',
  templateUrl: './zendesk-feedback-button.component.html',
  styleUrl: './zendesk-feedback-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton, MatTooltip],
})
export class ZendeskFeedbackButtonComponent {
  readonly isSmall: InputSignal<boolean> = input.required<boolean>();

  readonly openZendeskDialogClick: OutputEmitterRef<void> = output<void>();

  openZendeskDialog(): void {
    this.openZendeskDialogClick.emit();
  }
}
